<template>
    <base-spinner :open="isloading"></base-spinner>
    <form name="b2b-checkout"> 
        <div class="site__body">
            <div class="block-header block-header--has-breadcrumb block-header--has-title mt-10">
                <div class="container">
                    <div class="block-header__body">
                        <div class="flexbox-page-info-container">
                            <div class="flex-item-page-info-breadcrumbs">
                                <nav class="breadcrumb block-header__breadcrumb block-header__breadcrumb--and-title-only" aria-label="breadcrumb">
                                    <ol class="breadcrumb__list">
                                        <li class="breadcrumb__spaceship-safe-area" role="presentation"></li>
                                        <li class="breadcrumb__item breadcrumb__item--parent">
                                            <router-link to="/cart" class="breadcrumb__item-link">
                                                View Cart
                                            </router-link>
                                        </li>
                                        <li class="breadcrumb__item breadcrumb__item--current breadcrumb__item--last" aria-current="page">
                                            <span class="breadcrumb__item-link">Checkout</span>
                                        </li>
                                        <li class="breadcrumb__title-safe-area" role="presentation"></li>
                                    </ol>
                                </nav>
                            </div>
                            <div class="flex-item-page-info-title">
                                <h1 class="block-header__breadcrumb-slim">Checkout</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="checkout block">

                <div class="container container--max--xl">
                    <div class="row">
                        <!-- <div class="col-12">
                            <base-message v-if="!isloading" :servermessages="servermessages"></base-message>
                        </div> -->
                        <div class="col-12 col-md-12" v-if="errormessages.length > 0 || servermessages.length > 0">
                            <div class="alert alert-danger mb-3">
                                <!-- <strong>Please correct all of the errors listed below before proceding. <br/></strong> -->
                                <strong v-for="message in servermessages" :key="message">
                                    {{ message }} <br/>
                                </strong> 
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-6 col-xl-7">
                            <div class="card mb-lg-0">             
                                <billing-details
                                    :name="billingname"
                                    :address1="billingaddress1"
                                    :address2="billingaddress2"
                                    :city="billingcity"
                                    :state="billingstate"
                                    :zip="billingzip"
                                    :phone="billingphone"
                                    :email="customeremail"
                                ></billing-details>
                                <div class="card-divider"></div>
                                <shipping-diff :carrierlist="carrierlist" :uniquelocationlist="uniqueLocations" :defaultCarr="shippingcarrier"></shipping-diff>
                            </div>
                                <div class="block-space--layout--divider-20"></div>
                                <span v-if="uniquelocationlist.length > 1">
                                    <shipping-details
                                        v-for="loc in uniquelocationlist" 
                                        :key="loc.locationid" 
                                        :currentlocationid="loc.locationid"
                                        :name="shippingname"
                                        :address1="shippingaddress1"
                                        :address2="shippingaddress2"
                                        :city="shippingcity"
                                        :state="shippingstate"
                                        :zip="shippingzip"
                                        :phone="shippingphone"
                                        :defaultcarrier="defaultcarrier"
                                        :carrierlist="carrierlist"
                                        >
                                    </shipping-details>
                                </span>
                                <!-- <template v-for="line in cartlist" :key="line.linenumber">
                                    <shipping-details v-if="printHeader"
                                        :locationid="line.locationid"
                                        :name="shippingname"
                                        :address1="shippingaddress1"
                                        :address2="shippingaddress2"
                                        :city="shippingcity"
                                        :state="shippingstate"
                                        :zip="shippingzip"
                                        :phone="shippingphone"
                                        :defaultcarrier="defaultcarrier"
                                    ></shipping-details>
                                </template> -->

                            <!-- </div> -->
                        </div>
                        <div class="col-12 col-lg-6 col-xl-5 mt-4 mt-lg-0">
                            <div class="card mb-0">
                                <div class="card-body card-body--padding--1">
                                    <h3 class="card-title">Your Order</h3>

                                    <products-ordered :isCartItems='true' v-if="uniquelocationlist.length <= 1"></products-ordered>

                                    <div class="block-space block-space--layout--divider-thin"></div>
									<div class="block-space block-space--layout--divider-thin"></div>

                                    <promotional-code></promotional-code>

                                    <div class="block-space block-space--layout--divider-thin"></div>
                                    <div class="block-space block-space--layout--divider-thin"></div>
                                    <div class="block-space block-space--layout--divider-thin"></div>
                                    <checkout-totals-b></checkout-totals-b>
                                    <payment-methods-b></payment-methods-b>                                   
                                    <div class="checkout__agree form-group">
                                        <div class="form-check">
                                            <span class="input-check form-check-input">
                                                <span class="input-check__body">
                                                    <input class="input-check__input" type="checkbox" id="checkout-terms" v-model="termsacceptance" value="Y">
                                                    <span class=""></span>
                                                        <!-- <span class="input-check__icon"><svg width="9px" height="7px">
                                                                <path d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z" />
                                                        </svg>
                                                        </span> -->
                                                    </span>
                                                </span>
                                            <label class="form-check-label" for="checkout-terms">
                                                I have read and agree to the website <a href="javascript:void(0);">terms and conditions</a>.
                                            </label>
                                        </div>
                                    </div>
                                    <!-- <router-link to="/card-connect" class="btn btn-checkout btn-xl btn-block">
                                        Place Order
                                    </router-link> -->
                                    <!--  :disabled="this.cart.length < 1" -->
                                    <button type="button" class="btn btn-checkout btn-xl btn-block" @click.prevent="placeOrder">
                                        Place Order
                                    </button>


                                    <div class="block-space--layout--divider-nl"></div><br>
									<div v-if="showShipCutOffTime">
                                        <strong>Next Shipping Cutoff Time is {{cutOffTime}} in <span class='notranslate'>{{ cntdown }}</span>.</strong>
                                    </div>
                                </div>
                            </div>
                            <div class="block-space--layout--divider-20"></div>
                            <single-back-order-summary v-if="uniquelocationlist.length == 1"></single-back-order-summary>
                        </div>
                    </div>
                </div>
            </div>
            <div class="block-space block-space--layout--before-footer"></div>
        </div>  
    </form> 
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";
import BillingDetails from './BillingDetails';
import ShippingDetails from './ShippingDetails';
import CheckoutTotalsB from './CheckoutTotalsB'; 
import PaymentMethodsB from './PaymentMethodsB'; 
import SingleBackOrderSummary from './SingleBackOrderSummary'; 
import ProductsOrdered from './ProductsOrdered'; 
import PromotionalCode from '../checkoutb2c/PromotionalCode'; 
import ShippingDiff from './ShippingDiff'; 
import { mapGetters } from 'vuex';
import MixinCart from '../../../mixins/cart.js';
import Formatter from '../../../mixins/formatter.js';

export default {
    name: 'CheckoutB2B',
    components: {
        BillingDetails, 
        ShippingDetails,
        CheckoutTotalsB,
        PaymentMethodsB,
        ShippingDiff,
        SingleBackOrderSummary,
        ProductsOrdered,
        PromotionalCode
    },
    data() {
        return {
            billingname: '',
            billingaddress1: '',
            billingaddress2: '',
            billingcity: '',
            billingstate: '',
            billingzip: '',
            billingphone: 0,
            shippingname: '',
            shippingaddress1: '',
            shippingaddress2: '',
            shippingcity: '',
            shippingstate: '',
            shippingzip: '',
            shippingphone: 0,
            customeremail: '',
            defaultcarrier: '',
            cartlist: [],
            uniquelocationlist: [],
            requirespo: '',
            requirescc: '',
            CMNAME: null,
            ADCNNM: null,
            S2CNNM: null,
            CCSAVE: 'N',

            kit_po: '',
            kit_ord_num: '',

            termsacceptance: [],
            isloading: false,
            servermessages: [],
            errormessages: [],
            ordered_items: [],
            carrierlist: [],
            credit_settings: [],

            converted_date: null,
            cntdown: '',

            // credit settings fields
            Z8OCLA: '',
            Z8PDA: '',
            Z8OCLW: '',
            Z8PDW: '',

            // default messages
            past_due_msg: "You are past due to your balance.",
            over_limit_msg: "You are already over to your credit limit.",
        }
    },
    mixins: [
        Formatter,
        MixinCart
    ],
    methods: {
        getCheckoutMsg() {
            axiosvl.post(this.$store.getters['api/checkout_msgs_uri'], 
                {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        }
                    }
                }
            ).then((response) => { 
                const lists = response.data.webroutine.lists;
                const MSGLIST = lists.MSGLIST.entries;

                for (const key in MSGLIST) { 
					const obj = MSGLIST[key];
                    if(obj.LW3SVNAME == 'MSG:CC_PASTDUE'){
                        this.past_due_msg = obj.LW3SVVALP;
                    }
                    if(obj.LW3SVNAME == 'MSG:CC_OVERLIMIT'){
                        this.over_limit_msg = obj.LW3SVVALP;
                    }
				}
            }).catch(function (error) { 
                console.log("error - " + error);
            });
        },

        getCreditSettings() {
            this.credit_settings = [];

            axiosvl.post(this.$store.getters['api/wd_credit_settings_uri'], 
                {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": {
                                "value": this.$store.getters.customer
                            }
                        }
                    }
                }
            ).then((response) => { 
                const fields = response.data.webroutine.fields;
                console.table(fields);
                const RESULTCOD = fields.RESULTCOD.value;

                if(RESULTCOD == 'OK'){
                    this.Z8OCLA = fields.Z8OCLA.value;
                    this.Z8PDA  = fields.Z8PDA.value;
                    this.Z8OCLW = fields.Z8OCLW.value;
                    this.Z8PDW  = fields.Z8PDW.value;
                }
                
            }).catch(function (error) { 
                console.log("error - " + error);
            });
        },

        getCarriers() {
			this.carrierlist = [];

			axiosvl.post(this.$store.getters['api/get_carriers'], 
				{
					"webroutine": {
						"context": {
							"session-key-method": "hidden"
						},
						"fields": {
							"EHCUST": {
								"value": this.$store.getters.customer
							}
						}
					}
				}
			).then((response) => { 
				for (const key in response.data.webroutine.lists.CARRIERS.entries) { 
					const obj = response.data.webroutine.lists.CARRIERS.entries[key];

					this.carrierlist.push({ 
						carriercode: obj.CFCARR,
						carriername: obj.CFNAME,
						carrier_rate: 0,
					});

					if (this.defaultcarrier != '') {
						this.shippingcarrier = this.defaultcarrier;
					}
				}
				this.shippingcarrier = this.carrier;
				this.getCECarriers();
			}).catch(function (error) { 
				console.log("error - " + error);
			});
		},
		getCECarriers() {
            const totals = this.$store.getters['cart/totals'];
            // console.log(totals);
			axiosvl.post(this.$store.getters['api/ship_rate_uri'], 
				{
					"webroutine": {
						"context": {
							"session-key-method": "hidden"
						},
						"fields": {
							// "HOSTURL": {"value": this.$store.getters.hosturl},
                            "LW3SFID": { "value": this.$store.getters.storefront },
							"LW3CUSIND": {"value": this.$store.getters.customerIndicator},
							"LW3ORDTOT": {"value": totals[0].subtotal}
						}
					}
				}
			).then((response) => { 
				
				for (const key in response.data.webroutine.lists.LS_SHIPPINGRATES.entries) {
					const obj = response.data.webroutine.lists.LS_SHIPPINGRATES.entries[key];
                    
                    this.checkCarriers({
						carriercode: obj.LW3JSHPTY,
						carriername: obj.LW3SSHPDS,
						carrier_rate: obj.LW3SHPAMT,
					});

                    // this.carrierlist.push({
					// 	carriercode: obj.LW3JSHPTY,
					// 	carriername: obj.LW3SSHPDS,
					// 	carrier_rate: obj.LW3SHPAMT,
					// });
				}

                // console.log(this.carrierlist);
                

			}).catch(function (error) { 
				console.log("error - " + error);
			});
		},

        getCustomerInfo() {
            this.isloading = true;
            // this.servermessages = [];

            this.billingname = '', this.billingaddress1 = '', this.billingaddress2 = '', this.billingcity = '', this.billingstate = '', this.billingzip = '', this.billingphone = '', this.shippingname = '', this.shippingaddress1 = '', this.shippingaddress2 = '', this.shippingcity = '', this.shippingstate = '', this.shippingzip = '', this.shippingphone = '', this.customeremail = '';

            axiosvl.post(this.$store.getters['api/get_customer_info_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;
                // console.log(fields);
                let messages = [];

                if (fields.RESULTCOD.value === 'OK') {
                    this.billingname = fields.ADNAME.value;
                    this.billingaddress1 = fields.ADADD1.value;
                    this.billingaddress2 = fields.ADADD2.value;
                    this.billingcity = fields.ADCITY.value;
                    this.billingstate = fields.ADSTTC.value;
                    this.billingzip = fields.ADZIPC.value;
                    this.billingphone = fields.ADPHON.value;
                    this.CMNAME = fields.CMNAME.value;
                    this.ADCNNM = fields.ADCNNM.value;
                    this.S2CNNM = fields.S2CNNM.value;
                    if (fields.S2NAME.value === '' && fields.S2ADD1.value === '') {
                        this.shippingname = fields.ADNAME.value;
                        this.shippingaddress1 = fields.ADADD1.value;
                        this.shippingaddress2 = fields.ADADD2.value;
                        this.shippingcity = fields.ADCITY.value;
                        this.shippingstate = fields.ADSTTC.value;
                        this.shippingzip = fields.ADZIPC.value;
                        this.shippingphone = fields.ADPHON.value;
                    } else {
                        this.shippingname = fields.S2NAME.value;
                        this.shippingaddress1 = fields.S2ADD1.value;
                        this.shippingaddress2 = fields.S2ADD2.value;
                        this.shippingcity = fields.S2CITY.value;
                        this.shippingstate = fields.S2STTC.value;
                        this.shippingzip = fields.S2ZIPC.value;
                        this.shippingphone = fields.S2PHON.value;
                    }

                    this.defaultcarrier = fields.CMCARR.value;
                    this.requirespo = fields.CMPORQ.value;
                    this.customeremail = fields.ECEMAL.value;

                } else {
                    const wrmessages = response.data.webroutine.messages;

                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }

                    // Return code is not "OK" but no messages appear, add a custom error message
                    if (messages.length === 0) {
                        messages.push("Something went wrong. Please try again later.");
                    }
                }

                this.isloading = false;
                // this.servermessages = messages;
            })
            .catch((error) => {
                this.isloading = false;
                console.log("error - " + error);
            });
        },

        validateOrder() {
            this.isFormValid = true
            this.errormessages = [];
            let shippingdetails = this.$store.getters['cart/shippingdetails'];
            let cc_details = this.$store.getters['cart/cc_details'];

            // console.log('requirescc = ' + this.requirescc);
            if (this.requirescc === 'Y') {
                if (cc_details.cc_saved_id == ''){
                    /** Validate Credit Card details */
                    if(cc_details.cc_fname == null || cc_details.cc_lname == null){
                        // this.servermessages.push('Credit Card Name is required.');
                        this.errormessages.push({'input' : 'CC_Check', 'message': true});
                        this.errormessages.push({'input' : 'CC_Name', 'message': 'Credit Card Name is required.'});
                        this.isFormValid = false;
                    }

                    if(cc_details.cc_exp_mo == null ){
                        // this.servermessages.push('Credit Card Expiration month is required.');
                        this.errormessages.push({'input' : 'CC_Check', 'message': true});
                        this.errormessages.push({'input' : 'CC_Mo', 'message': 'Expiration month is required.'});
                        this.isFormValid = false;
                    }

                    if(cc_details.cc_exp_yr == null){
                        // this.servermessages.push('Credit Card Expiration year is required.');
                        this.errormessages.push({'input' : 'CC_Check', 'message': true});
                        this.errormessages.push({'input' : 'CC_Year', 'message': 'Expiration Year is required.'});
                        this.isFormValid = false;
                    }

                    if(cc_details.cc_cvv == null){
                        // this.servermessages.push('Credit Card CVV is required.');
                        this.errormessages.push({'input' : 'CC_Check', 'message': true});
                        this.errormessages.push({'input' : 'CC_CVV', 'message': 'CVV is required.'});
                        this.isFormValid = false;
                    }
                    
                    if(cc_details.cc_zip == null){
                        // this.servermessages.push('Credit Card Zipcode is required.');
                        this.errormessages.push({'input' : 'CC_Check', 'message': true});
                        this.errormessages.push({'input' : 'CC_Zip', 'message': 'Zipcode is required.'});
                        this.isFormValid = false;
                    }
                    console.log(cc_details);
                    if(cc_details.cc_country == null){
                        // this.servermessages.push('Credit Card Zipcode is required.');
                        this.errormessages.push({'input' : 'CC_Check', 'message': true});
                        this.errormessages.push({'input' : 'CC_Country', 'message': 'Country is required.'});
                        this.isFormValid = false;
                    }
                }
            }

            // console.log('requirespo = ' + this.requirespo);
            if (this.requirespo === 'Y') {
                const purchaseorder = this.$store.getters['cart/purchaseorder'];
                if(purchaseorder == ''){
                    this.errormessages.push({'input' : 'PO', 'message': 'Purchase Order Number is required.'});
                    this.isFormValid = false;
                }
            }

            if (this.termsacceptance != 'Y') {
                this.servermessages.push('Please accept the website terms and conditions to place your order.');
                // this.errormessages.push({'input' : 'terms', 'message': 'Please accept the website terms and conditions to place your order.'});
                this.isFormValid = false;
            }

            // console.log(shippingdetails);
            // console.log(this.shippingDifferent);
            
            /** Validate Shipping */
            if(this.shippingDifferent == true){
                if(shippingdetails.shippingname.trim() == ''){
                    // this.servermessages.push('Shipping Name is required.')
                    this.errormessages.push({'input' : 'SName', 'message': 'Shipping Name is required.'});
                    this.isFormValid = false;
                }

                // if(shippingdetails.shippingname.trim() == ''){
                //     // this.servermessages.push('Shipping Name is required.')
                //     this.errormessages.push({'input' : 'SName', 'message': 'Shipping Name is required.'});
                //     this.isFormValid = false;
                // }

                if(shippingdetails.shippingaddress1.trim() == ''){
                    // this.servermessages.push('Shipping Address is required.')
                    this.errormessages.push({'input' : 'SAddress', 'message': 'Shipping Address is required.'});
                    this.isFormValid = false;
                }

                if(shippingdetails.shippingcity == ''){
                    // this.servermessages.push('Shipping Phone is required.')
                    this.errormessages.push({'input' : 'SCity', 'message': 'Shipping City is required.'});
                    this.isFormValid = false;
                }

                if(shippingdetails.shippingzip.trim() == ''){
                    // this.servermessages.push('Shipping State is required.')
                    this.errormessages.push({'input' : 'SZip', 'message': 'Zip is required.'});
                    this.isFormValid = false;
                }

                if(shippingdetails.shippingstate.trim() == ''){
                    // this.servermessages.push('Shipping State is required.')
                    this.errormessages.push({'input' : 'SState', 'message': 'Shipping State is required.'});
                    this.isFormValid = false;
                }
            }
            
            // if (this.$store.getters['cart/carrier'] === '') {
            //     // this.servermessages.push('Carrier is required.');
            //     this.errormessages.push({'input' : 'shipCarrier', 'message': 'Carrier is required.'});
            //     this.isFormValid = false;
            // }
            // console.log(this.errormessages);
            if(this.errormessages.length > 0){
                this.servermessages.push('Please correct all of the errors listed below before proceding. ');
            }
            this.$store.dispatch('setErrorFields', this.errormessages);

            return this.isFormValid;
        },
        buildPartsToOrder() {
            let parts = [];

            this.$store.getters['cart/cart'].forEach(cartitem => {
                let itemlocation = cartitem.locationid === undefined ? this.getDefaultLocationDetails.defaultlocationid : cartitem.locationid;
                let isBackOrder = (cartitem.backorder == true) ? "Y" : "";
                parts.push([
                    cartitem.manufacturer, // EKMFGC
                    cartitem.item,      // EKITMC
                    cartitem.quantity, // EKOQTY
                    isBackOrder, // EKBOCD
                    "", // EKCPO#
                    itemlocation, // EKLOCN
                    cartitem.carrier, // EKCARR
                    cartitem.yourprice,  // EKEXCP
                    cartitem.corecharge, // EKCORP
                    ''                  // EKKITF
                ]);
            });

            this.$store.getters['cart/kits'].forEach(kitem => {
                let itemlocation = kitem.locationid === undefined ? this.getDefaultLocationDetails.defaultlocationid : kitem.locationid;
                let isBackOrder = (kitem.backorder == true) ? "Y" : "";
                parts.push([
                    kitem.mfgcode, // EKMFGC
                    kitem.kitnumber,      // EKITMC
                    kitem.quantity, // EKOQTY
                    isBackOrder, // EKBOCD
                    "", // EKCPO#
                    itemlocation, // EKLOCN
                    kitem.carrier, // EKCARR
                    kitem.yourprice,  // EKEXCP
                    kitem.corecharge, // EKCORP
                    kitem.EKKITF // EKKITF
                ]);

                kitem.kit_items.forEach(kcomp => {
                    let itemlocation = kcomp.locationid === undefined ? this.getDefaultLocationDetails.defaultlocationid : kcomp.locationid;
                    let isBackOrder = (kcomp.backorder == true) ? "Y" : "";
                    parts.push([
                        kcomp.manufacturer, // EKMFGC
                        kcomp.item,      // EKITMC
                        kcomp.quantity, // EKOQTY
                        isBackOrder, // EKBOCD
                        "", // EKCPO#
                        itemlocation, // EKLOCN
                        kcomp.carrier, // EKCARR
                        kcomp.yourprice,  // EKEXCP
                        kcomp.corecharge, // EKCORP
                        'C'                  // EKKITF
                    ]);
                });
            });

            return parts;
        },
        placeOrderData() {
            let fields = {};
            let shippingdetails = this.$store.getters['cart/shippingdetails'];

            let billingdetails = this.$store.getters['cart/billingdetails'];
            // let getTotal = this.$store.getters['cart/totals'];
            const totals = this.$store.getters['cart/totals'];
            const orderTotal = parseFloat(totals[0].ordertotal)
            const passwords = this.$store.getters.passwords;
            
            let shipcountry = shippingdetails.shippingcountry === undefined ? '' : shippingdetails.shippingcountry;

            let cc_details = this.$store.getters['cart/cc_details'];
            console.log(cc_details);
            fields = {
                "B2CTEMPLATE": {"value": this.$store.getters.defaultB2Ccustomer},
                "PPICC": {"value": cc_details.cc_token},
                "MNTH": {"value": cc_details.cc_exp_mo},
                "YR": {"value": cc_details.cc_exp_yr},
                "CCCVV": {"value": cc_details.cc_cvv},
                "CCFIRST": {"value": cc_details.cc_fname},
                "CCLAST": {"value": cc_details.cc_lname},
                "CCADDR": {"value": ""},
                "CCZIP": {"value": cc_details.cc_zip},
                "CCSAVE": {"value": cc_details.to_save_new_cc},
                "CCSAVED": {"value": cc_details.cc_saved_id},
                "CCTOT": {"value": orderTotal},
                "TETYPE": {"value": 'VC'},

                "EHCUST": {"value": this.$store.getters.customer},
                "EHPONO": {"value": this.$store.getters['cart/purchaseorder']},
                "EHCARR": {"value": this.$store.getters['cart/carrier']},
                "EHORD#": {"value": ""},

                "CMNAME": {"value": this.CMNAME},
                "ECEMAL": {"value": this.customeremail},
                "UPPASS": {"value": passwords.newpassword},
                "ADNAME": {"value": billingdetails.billingname},
                "ADADD1": {"value": billingdetails.billingaddress1},
                "ADADD2": {"value": billingdetails.billingaddress2},
                "ADCITY": {"value": billingdetails.billingcity},
                "ADSTTC": {"value": billingdetails.billingstate},
                "ADCTRC": {"value": billingdetails.billingcountry},
                "ADZIPC": {"value": billingdetails.billingzip},
                "ADPHON": {"value": billingdetails.billingphone},
                "ADCNNM": {"value": this.ADCNNM},
                
                "S2NAME": {"value": shippingdetails.shippingname},
                "S2ADD1": {"value": shippingdetails.shippingaddress1},
                "S2ADD2": {"value": shippingdetails.shippingaddress2},
                "S2CITY": {"value": shippingdetails.shippingcity},
                "S2STTC": {"value": shippingdetails.shippingstate},
                "S2CTRC": {"value": shipcountry},
                "S2ZIPC": {"value": shippingdetails.shippingzip},
                "S2PHON": {"value": shippingdetails.shippingphone},
                "S2CNNM": {"value": this.S2CNNM},

                "FREIGHT": {"value": totals[0].shippingtotal},
                "TAXES": {"value": totals[0].taxtotal},
                "CEDKOE": {"value": this.cedkoe},

                "FORCENEWCUST": {"value": "N"},

                "ORDMSG": {"value": this.$store.getters['cart/ordernotes']}
            }

            return fields;
        },
        placeOrder() {
            this.isloading = true;
            this.servermessages = [];
           
            if (!this.validateOrder()) {
                // alert('error found');
                window.scrollTo(0, 0);
                this.isloading = false;
                return;
            }

            let reqFields = this.placeOrderData();
            let partsList = this.buildPartsToOrder();
            const params = {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": reqFields,
                    "lists": {
                        "PARTSO": {
                            "header": [
                                {"name": "EKMFGC"},
                                {"name": "EKITMC"},
                                {"name": "EKOQTY"},
                                {"name": "EKBOCD"},
                                {"name": "EKCPO#"},
                                {"name": "EKLOCN"},
                                {"name": "EKCARR"},
                                {"name": "EKEXCP"},
                                {"name": "EKCORP"},
                                {"name": "EKKITF"}
                            ],
                            "entries": partsList
                        }
                    }
                }
            }

            // console.log(params);
            // // for testing 
            // const test = true;
            // if(test){
            //     return false;
            // }

            axiosvl.post(this.$store.getters['api/cc_new_order'], params)
            .then((response) => {
                const fields = response.data.webroutine.fields;
                const lists = response.data.webroutine.lists;
                const OSDETS_list = lists.OSDETS.entries;
                // console.log(OSDETS_list);
                // const BORDERS_list = lists.BORDERS.entries;
                
                // let messages = [];
                this.ordered_items = [];

                if (fields.RESULTCOD.value == 'OK') {

                    // email orders success 
                    this.emailSuccessOrder(response.data);

                    let paymentmethod = '';
                    if (this.$store.getters['cart/paymenttype'] === 'CC') {
                        paymentmethod = "Credit Card";
                    } else {
                        paymentmethod = "Purchase Order";
                    }

                    this.$store.dispatch('cart/ordersuccess', {
                        "ordernumber": fields['HAORD#'].value,
                        "orderdate": (fields.XROESM.value + '/' + fields.XROESD.value + '/' + fields.XROESY.value),
                        "paymentmethod": paymentmethod
                    });

                    // build ordered items fromo the response
                    OSDETS_list.forEach(item => {
                        
                        if(item.DIDESC.indexOf("KIT END") >= 0){
                            // console.log('KIT END SKIP');
                            this.kit_po =  item.DICPONUM;
                            this.kit_ord_num =  item.DIORDNUM;
                            return;
                        }

                        const isProd = this.cart.find(c => (c.item == item.DIITMC) && (c.manufacturer == item.DIMFGC));

                        if(!isProd){
                            return;
                        }

                        this.ordered_items.push({
                            "po_number" : item.DICPONUM,
                            "ord_number" : item.DIORDNUM,
                            "product_id": item.DIITMC,
                            "product_name": item.DIITMC,
                            "product_desc": item.DIDESC,
                            "image"       : this.getProductImage(item.DIITMC),
                            "XRITMC"      : this.getProductXRITMC(item.DIITMC),
                            // "product_desc": item.desc,
                            "price": item.DIEPRX,
                            "quantity": item.DIORQT,
                            "bo_quantity": item.DIBOQX,
                            "total_item": item.TOLITM,

                            "customer": item.DICUST,
                            // "customer_desc": item.DIDESC,

                            "locationid": item.DILOC,
                            "locationcity": item.ADCITY,
                            "locationname": item.LCNAME,
                            "locationnamel": item.LCNAMEL,
                            "locationstate": item.ADSTTC,
                            "manufacturer": item.DIMFGC,
                            
                            "order_number": item.EJORDNUM,
                            "kit_components": []
                        });

                    });

                    // console.log('kit PO = ' + this.kit_po);
                    // console.log('kit ORD NUM = ' + this.kit_ord_num);

                    this.kits.forEach(km => {
                        // console.log(item);
                        this.ordered_items.push({
                            "po_number" : this.kit_po,
                            "ord_number" : this.kit_ord_num,
                            "product_id": km.kitnumber,
                            "product_name": km.desc,
                            "product_desc": km.desc,
                            "image"       : this.getProductImage(km.kitnumber),
                            "XRITMC"      : '',
                            // "product_desc": item.desc,
                            "price"       : km.kit_gtotal,
                            "quantity"    : km.kitqy,
                            "bo_quantity" : '',
                            "total_item"  : '',
                            "customer"    : this.$store.getters.customer,
                            // "customer_desc": item.DIDESC,
                            "locationid"  : km.locationid,
                            "locationcity": km.locationcity,
                            "locationname": km.locationid,
                            "locationnamel": '',
                            "locationstate": km.locationstate,
                            "manufacturer": km.mfgcode,
                            
                            "order_number": this.kit_ord_num,
                            "kit_components": km.kit_items
                        });
                    });


                    console.log(this.ordered_items);
                    this.$store.dispatch('cart/ordered_items', this.ordered_items);
                    // this.$store.dispatch('cart/backordered_items', BORDERS_list);

                    this.$router.push("/order-success");
                } else {

                    let HDM = this.storefrontAttributes.find(attribute => attribute.type === 'HDM').value;
                    
                    if(fields.RESULTCOD.value === 'PAYFAIL'){
                        this.servermessages.push("Credit card payment unsuccessful. Please contact Customer Service.");
                    }else{
                        this.servermessages.push("Your order could not be placed. Please contact Customer Service.");
                    }

                    if(HDM != 'Y'){
                        const wrmessages = response.data.webroutine.messages;
                        for (var i = 0; i < wrmessages.length; i++) {
                            // console.log(wrmessages[i]);
                            this.servermessages.push(wrmessages[i]);
                        }
                    }
                    
                }

                this.isloading = false;
                // this.servermessages = messages;
            })
            .catch((error) => {
                this.isloading = false;
                let messages = [];
                messages.push("Your order could not be placed. Please contact Customer Service.");
                this.servermessages = messages;
                console.log("error - " + error);
            });

        },
        // buildCartListDisplay() {
        //     this.cartlist = [];

        //     this.cart.forEach((item, i) => {
        //         let productimage = '';

        //         // if (item.image.includes('http')) {
        //         //     productimage = item.image;
        //         // } else if (item.image != '') {
        //         //     productimage = this.image_domain_category + '/' + item.image;
        //         // } else {
        //         //     productimage = '';
        //         // }

        //         console.log('buildCartListDisplay - ' + JSON.stringify(this.customerlocationlist));

        //         let itemlocationid = '', itemlocationname = '', itemlocationcity = '', itemlocationstate = '';

        //         if (item.locationid === undefined) {
        //             itemlocationid = this.getDefaultLocationDetails.defaultlocationid;
        //             itemlocationname = this.getDefaultLocationDetails.defaultlocationname;
        //             itemlocationcity = this.getDefaultLocationDetails.defaultlocationcity;
        //             itemlocationstate = this.getDefaultLocationDetails.defaultlocationstate;
        //         } else {
        //             itemlocationid = item.locationid;
        //             itemlocationname = item.locationname;
        //             itemlocationcity = item.locationcity;
        //             itemlocationstate = item.locationstate;
        //         }

        //         let cartdata = {
        //             "cartIndex": i,
        //             "ID": item.ID,
        //             "sku": item.item,
        //             "desc": item.desc,
        //             "manufacturer": item.manufacturer,
        //             "image": productimage,
        //             "quantity": item.quantity,
        //             "listprice": item.listprice,
        //             "corecharge": item.corecharge,
        //             "yourprice": item.yourprice,
        //             "shipping": item.shipping,
        //             "linetotal": item.linetotal,
        //             "stockquantity": item.stockquantity,
        //             "backorder": item.backorder,
        //             "cartlocationid": item.locationid,
        //             "cartlocationname": item.locationname,
        //             "cartlocationcity": item.locationcity,
        //             "cartlocationstate": item.locationstate,
        //             "locationid": itemlocationid,
        //             "locationname": itemlocationname,
        //             "locationcity": itemlocationcity,
        //             "locationstate": itemlocationstate,
        //             "pageQty": item.quantity,
        //             "printHeader": "N"
        //         }
        //         this.cartlist.push(cartdata);
        //     });

        //     this.cartlist.sort((a,b) => (a.locationid > b.locationid) ? 1 : ((b.locationid > a.locationid) ? -1 : 0));

        //     let prevlocationid = '';

        //     // Add flags for each unique location after sorting to handle the display
        //     this.cartlist.forEach((item, i) => {
        //         if (i === 0 || prevlocationid != item.locationid) {
        //             prevlocationid = item.locationid;
        //             this.cartlist[i].printHeader = 'Y';
        //         }
        //     });
        // },

        shipCutOffTimer(){
            let time = parseInt(this.storefrontAttributes.find(attribute => attribute.type === 'SCT').value);
            time = time.toString().substring(0, 2) + ':' + time.toString().substring(2, 4);
            const STZ_val = this.storefrontAttributes.find(attribute => attribute.type === 'STZ').value;
           
            var currYear = new Date().getFullYear();
            var currDay = new Date().getUTCDate();
            var currMo = new Date().getUTCMonth() + 1;
            var setDate = currMo + '/'+ currDay + '/'+ currYear + " " + time + " " + STZ_val;

            const cutoff = new Date(setDate);
            // console.log('CUTOFF = ' + cutoff);
            const today = new Date();
            // console.log(today);
            
            var diff = cutoff - today;  

            var msec = diff;
            var hh = Math.floor(msec / 1000 / 60 / 60);
            msec -= hh * 1000 * 60 * 60;
            var mm = Math.floor(msec / 1000 / 60);
            msec -= mm * 1000 * 60;
            var ss = Math.floor(msec / 1000);

            if(hh.toString().length == 1){
                hh = '0' + hh;
            }

            if(mm.toString().length == 1){
                mm = '0' + mm;
            }
            
            if(ss.toString().length == 1){
                ss = '0' + ss;
            }

            this.cntdown = hh + ':' + mm + ':' + ss;
        },

        customer_billing_status() {
            axiosvl.post(this.$store.getters['api/cust_credit_status_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;
                console.table(fields);
                if (fields.RESULTCOD.value === 'OK') {
                    this.requirescc = fields.CCONLY.value;
                }

                if(this.Z8PDW == 'Y' && fields.PASTDUE.value != ''){
                    this.servermessages.push(this.past_due_msg);
                }
                // 
                if(this.Z8OCLW == 'Y' && fields.OVERLIMIT.value != ''){
                    this.servermessages.push(this.over_limit_msg);
                }

                if(this.Z8PDA == '1' && fields.PASTDUE.value != ''){
                    this.requirescc = 'Y';
                }

                if(this.Z8OCLA == '1' && fields.OVERLIMIT.value != ''){
                    this.requirescc = 'Y';
                }

                // console.log('requirescc = ' + this.requirescc);
            })
            .catch((error) => {
                this.isloading = false;
                console.error("error - " + error);
            });
        },

        buildUniqueLocations() {
            this.uniquelocationlist = [];
            // console.log(this.cart);
            // fetch cart item location
            // else get default location
            let uniques = [... new Set(this.cart.map((item) => 
                item.locationid === undefined ? this.getDefaultLocationDetails.defaultlocationid : item.locationid
                // item.locationid
            ))];

            console.log(this.getDefaultLocationDetails);
            console.log(uniques);
            uniques.forEach(loc => {
                if (loc != '' || loc != undefined){
                    this.uniquelocationlist.push({
                        "locationid": loc,
                        "locationsequence": this.customerlocationlist.find(custloc => custloc.locationid === loc.locationsequence)
                    });
                }                
            });

            // uniques.sort((a,b) => (a > b) ? 1 : ((b > a) ? -1 : 0));
            this.uniquelocationlist.sort((a,b) => (a.locationsequence > b.locationsequence) ? 1 : ((b.locationsequence > a.locationsequence) ? -1 : 0));

            // console.log(this.uniquelocationlist);

            // console.log('buildUniqueLocations - ' + JSON.stringify(this.uniquelocationlist));

            // return this.uniquelocationlist;
        },

        // get product image
        getProductImage(product_id) {
            let kitc;
            // product / items
            const prod = this.$store.getters['cart/cart'].find(item => {
                return (item.ID == product_id)
            });
            
            if(prod){
                return prod.image;
            }

            // kit master
            const kitm = this.$store.getters['cart/kits'].find(kit => {
                return (kit.kitnumber == product_id)
            });

            if(kitm){

                return kitm.image;
            }

            // kit components
            this.$store.getters['cart/kits'].forEach(kit => {
                kitc = kit.kit_items.find(i => (i.item == product_id));
            });

            if(kitc){
                return kitc.image;
            }

            return '';
        },

        getProductXRITMC(product_id) {
            let kitc;
            const prod = this.$store.getters['cart/cart'].find(item => {
                return (item.ID == product_id)
            });

            // console.log(prod);
            if(prod){
                return prod.XRITMC;
            }

            // kit master
            const kitm = this.$store.getters['cart/kits'].find(kit => {
                return (kit.item == product_id)
            });

            if(kitm){
                return kitm.XRITMC;
            }

            // kit components
            this.$store.getters['cart/kits'].forEach(kit => {
                kitc = kit.kit_items.find(i => (i.item == product_id));
            });

            if(kitc){
                return kitc.XRITMC;
            }
            
            return '';
        },

        checkCarriers(carrier) {
			const check = this.carrierlist.find(c => c.carriercode == carrier.carriercode);
			if(check != undefined){
				const new_carriers = this.carrierlist.map(data => {
					if (carrier.carriercode == data.carriercode){
						return carrier;
					}else{
						return data;
					}
				});
				this.carrierlist = new_carriers;
			}else{
				this.carrierlist.push(carrier);
			}

            // console.log(this.carrierlist);

		},

        emailSuccessOrder(order_resp){
            const params = order_resp;
            const OSDETS_entries = params.webroutine.lists.OSDETS.entries;

            params.webroutine.fields.LW3SFID = {value : this.storefront};
            params.webroutine.fields.ECEMAL = {value : this.customeremail};
            this.isloading = true;
            const osdEntries = [];
            OSDETS_entries.forEach(entry => {
                osdEntries.push([
                    entry.OSDETL,
                    entry.DIORQT,
                    entry.DISHQW,
                    entry.DIBOQX,
                    entry.DIMFGC,
                    entry.DIITMC,
                    entry.DIDESC,
                    entry.DIEPRX,
                    entry.DICPRX,
                    entry.TOLITM,
                    entry.DICUST,
                    entry.XRMFGC,
                    entry.XRITMC,
                    entry.XRDESC,
                    entry.DICPONUM,
                    entry.DIDISNUM,
                    entry.DIORDNUM,
                    entry.DIDISL,
                    entry.DILOC,
                    entry.LCNAME,
                    entry.ADCITY,
                    entry.ADSTTC,
                    entry.LCNAMEL,
                    entry.EJORDNUM,
                ]);
            });

            params.webroutine.lists.OSDETS.entries = osdEntries;
            console.log(params);

            axiosvl.post(this.$store.getters['api/email_ord_succ_uri'], params)
            .then((response) => {
                this.isloading = false;
                console.log(response);
            })
            .catch((error) => {
                console.log(error);
                this.isloading = false; 
            });
        }
    },
    computed: {
        ...mapGetters([
            'customerIndicator',
            'storefrontAttributes',
            'getDefaultLocationDetails',
            'storefront'
        ]),
        ...mapGetters("cart", [
            "cart",
            "shippingDifferent",
            'kits',
            'promo_code',
            'cedkoe'
        ]),
        showShipCutOffTime() {
            if (this.storefrontAttributes.length > 0) {
                return this.storefrontAttributes.find(attribute => attribute.type === 'SST').value === 'Y';
            } else {
                return false;
            }
        },

        cutOffTime(){
            let time = parseInt(this.storefrontAttributes.find(attribute => attribute.type === 'SCT').value);
            time = time.toString().substring(0, 2) + ':' + time.toString().substring(2, 4);
            const STZ_val = this.storefrontAttributes.find(attribute => attribute.type === 'STZ').value;
           
            var currYear = new Date().getFullYear();
            var currDay = new Date().getUTCDate();
            var currMo = new Date().getUTCMonth() + 1;
            var setDate = currMo + '/'+ currDay + '/'+ currYear + " " + time + " " + STZ_val;
            // var setDate = "7/22/2021 16:15 GMT-05:00";
            // console.log(setDate);
            const d = new Date(setDate);
            // console.log(d);
            const localTime = d.toLocaleTimeString();
            console.log(localTime);
            const localArr = localTime.split(" ");
            const timeArr = localArr[0].split(':');
            const hhmm = timeArr.slice(0, 2).join(':');
            const ampm = (localArr[1] != undefined) ? localArr[1] : 'AM'; 

            return hhmm + ampm;
        },

        cutOffM() {
            let time = parseInt(this.storefrontAttributes.find(attribute => attribute.type === 'SCT').value);

            if (time > 1200){
                return 'pm';
            }else{
                return 'am';
            }

        },

        cutOffTimeZone() {
            return this.storefrontAttributes.find(attribute => attribute.type === 'STZ').value;
        },

        // shipCutOffTimer(){
        //     let time = parseInt(this.storefrontAttributes.find(attribute => attribute.type === 'SCT').value);
        //     time = time.toString().substring(0, 2) + ':' + time.toString().substring(2, 4);
        //     const STZ_val = this.storefrontAttributes.find(attribute => attribute.type === 'STZ').value;
           
        //     var currYear = new Date().getFullYear();
        //     var currDay = new Date().getUTCDate();
        //     var currMo = new Date().getUTCMonth() + 1;
        //     var setDate = currMo + '/'+ currDay + '/'+ currYear + " " + time + " " + STZ_val;

        //     const cutoff = new Date(setDate);
        //     const today = new Date();
            
        //     var diff = today - cutoff;  

        //     var msec = diff;
        //     var hh = Math.floor(msec / 1000 / 60 / 60);
        //     msec -= hh * 1000 * 60 * 60;
        //     var mm = Math.floor(msec / 1000 / 60);

        //     if (hh < 0){
        //         return ' the next day';
        //     }

        //     return ' in ' + hh + ' hours ' + mm + ' mins';
        // },

        uniqueLocations() {
            let uniques = [... new Set(this.cart.map((item) => 
                item.locationid === undefined ? this.getDefaultLocationDetails.defaultlocationid : item.locationid
            ))];

            if(uniques.length == 0) {
                uniques = [... new Set(this.kits.map((kit) => 
                    kit.locationid === undefined ? this.getDefaultLocationDetails.defaultlocationid : kit.locationid
                ))];
            }

            uniques.sort((a,b) => (a > b) ? 1 : ((b > a) ? -1 : 0));

            // console.log(this.kits.map((kit) => 
            //     kit.locationid === undefined ? this.getDefaultLocationDetails.defaultlocationid : kit.locationid
            // ));

            // console.log(uniques);

            return uniques;
        }

    },

    async mounted() {
        // if(!this.$store.getters['userIsAuthenticated']) {
        //     this.$router.push("/login");
        // }
        // Initialize values
        this.billingname = '', this.billingaddress1 = '', this.billingaddress2 = '', this.billingcity = '', this.billingstate = '', this.billingzip = '', this.billingphone = '', this.shippingname = '', this.shippingaddress1 = '', this.shippingaddress2 = '', this.shippingcity = '', this.shippingstate = '', this.shippingzip = '', this.shippingphone = '', this.customeremail = '';
        await this.mx_getLocationDetails();
        await this.buildUniqueLocations();
        this.getCustomerInfo();
        this.shipCutOffTimer();
        setInterval(this.shipCutOffTimer, 1000);

        this.customer_billing_status();

        this.getCECarriers();
    },

    created() {
        this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });
        // console.log(this.uniquelocationlist);       
        // console.table(this.promo_code);
        this.getCheckoutMsg();

        this.getCreditSettings();
    },

    updated() {
        const custDetails = this.$store.getters.getCustomerDetails;
        this.shippingcarrier = custDetails.defaultcarrier;
        // console.log('this.shippingcarrier = ' + this.shippingcarrier);
    }
}
</script>